import { Wrapper } from '@american-autonomy/ag-ui';

import DataTableDropdown from 'components/DataTableDropdown';
import Grid from 'components/Grid';

import { CONTENT_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WithDataHeader: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <Grid className={`${className} ${styles.withDataHeader}`} testId={testId}>
        <DataTableDropdown className={styles.dataTableDropdown} />

        <Wrapper className={styles.content} testId={CONTENT_TEST_ID}>
            {children}
        </Wrapper>
    </Grid>
);

export default WithDataHeader;
